import { Button, ButtonVariants } from "@centricsoftware/design-system";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { SAVE_GO_RES, SAVE_NEW_RES } from "csi/components/constants";
import { useFormStore } from "../FormStore";

export const NewFormFooter: FC = observer(() => {
	const { canRepeat, canNavigate, onSaveAndGo, onSaveAndNew } = useFormStore();
	const { secondary } = ButtonVariants;

	return (
		<>
			{canNavigate && (
				<Button
					childrenRes={SAVE_GO_RES}
					onClick={onSaveAndGo}
					variant={secondary}
				/>
			)}
			{canRepeat && (
				<Button
					childrenRes={SAVE_NEW_RES}
					onClick={onSaveAndNew}
					variant={secondary}
				/>
			)}
		</>
	);
});
